import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { IndAction } from '../../models/itens.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-itens-ind-action',
  templateUrl: './itens-ind-action.component.html',
  styleUrls: ['./itens-ind-action.component.scss','../itens-edit/itens-edit.component.scss']
})
export class ItensIndActionComponent extends BaseFormComponent<any> implements OnInit {
  @Input() parentFormGroup: FormGroup = null;
  @Input() currentItem: object[] = [];
  @Input() formName: string = null;
  constructor(
    public activatedRoute: ActivatedRoute,
  ) { 
    super(activatedRoute);
  }
  ngOnInit() {
  }

  get actions(): FormArray {
    return this.parentFormGroup.get('actions') as FormArray;
  }
}
